import VeeValidate from 'vee-validate'
import rules from './customRules'

const validation = {
    install(app, options) {
        Object.keys(rules).forEach((ruleName) => {
            var rule = rules[ruleName]
            VeeValidate.Validator.extend(ruleName, rule)
        })
        app.use(VeeValidate, {
            events: 'input|blur'
        })
    }
}

export default validation
